var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 5.873,
    viewBox: "0 0 10 5.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vectorMask",
    d: "M1196.85,2119.511l-.361-.361a.511.511,0,0,0-.723,0l-3.766,3.766-3.765-3.766a.511.511,0,0,0-.723,0l-.362.361a.512.512,0,0,0,0,.723l4.489,4.489a.511.511,0,0,0,.723,0l4.488-4.489A.51.51,0,0,0,1196.85,2119.511Z",
    transform: "translate(-1187 -2119)",
    fill: "#2e384d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down_arrow_icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Caret",
    "data-name": "Mask by Caret",
    transform: "translate(-3 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base_Color_White",
    "data-name": "Base/Color/White"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base_Color_Blue",
    "data-name": "Base/Color/Blue",
    width: 16,
    height: 16,
    fill: "#2e384d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down_arrow_icon.e48881aa75e5f8e999e74b60068fba56.svg";
export { ForwardRef as ReactComponent };